import styled from "styled-components";
import { Button as MuiButton } from "@mui/material";

export const UploadContainer = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #3024E1;
  border-radius: 16px;
  background-color: #F5F5F5;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #EBEBEB;
    border-color: #1E17A0;
  }
`;

export const FilePreview = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid #0000003B;
  background-color: #FAFAFA;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const FileName = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #191c1a;
  word-break: break-word;
`;

export const FileSize = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #666;
`;

export const ActionButton = styled(MuiButton)`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-transform: none;
  white-space: nowrap;

  &:hover {
    background-color: rgba(48, 36, 225, 0.08);
  }
`;
